<template>
  <v-layout v-if="loading" align-center justify-center style="height: calc(100vh - 100px)">
    <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
  </v-layout>
  <v-layout v-else :key="type" class="px-4 mb-5">
    <v-layout 
      row
      wrap
      v-if="(type === 'alerts' && (incidentsCount || general_alerts.length > 0)) ||
        (type === 'events' && incidentsCount)"
    >
      <v-flex xs12 style="margin-top: 30px">
        <div class="tabs-items">
          <div grid-list>
            <v-layout row wrap>
              <v-flex xs12>
                <v-card class="blue-rounded-card pa-3" style="background-color: white !important; overflow: auto">
                  <v-layout>
                    <v-flex xs3>
                      <v-layout>
                        <v-flex xs4 md3>
                          <img v-if="type === 'events'" class="imagePlace" src="@/assets/images/eventImg.png" alt="" />
                          <img v-else class="imagePlace" src="@/assets/images/alertImg.png" alt="" />
                        </v-flex>
                        <v-flex xs8 md9>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <h1 class="font-34 text-bold">{{ incidentsCount }}</h1>
                            </v-flex>
                            <v-flex xs12>
                              <h4 class="font-16">{{ type === 'events' ? $t('Events') : $t('Cabinets With Alerts') }}</h4>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs4 sm3 xl2>
                      <v-layout>
                        <v-flex xs4 md3>
                          <img class="imagePlace" src="@/assets/images/red.png" alt="" />
                        </v-flex>
                        <v-flex xs8 md9>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <h1 class="font-34 text-bold">{{ high }}</h1>
                            </v-flex>
                            <v-flex xs12>
                              <h4 class="font-16">{{ $t('High') }}</h4>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs4 sm3 xl2>
                      <v-layout>
                        <v-flex xs4 md3>
                          <img class="imagePlace" src="@/assets/images/yellow.png" alt="" />
                        </v-flex>
                        <v-flex xs8 md9>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <h1 class="font-34 text-bold">{{ mid }}</h1>
                            </v-flex>
                            <v-flex xs12>
                              <h4 class="font-16">{{ $t('Medium') }}</h4>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs4 sm3 xl2>
                      <v-layout>
                        <v-flex xs4 md3>
                          <img class="imagePlace" src="@/assets/images/green.png" alt="" />
                        </v-flex>
                        <v-flex xs8 md9>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <h1 class="font-34 text-bold">{{ low }}</h1>
                            </v-flex>
                            <v-flex xs12>
                              <h4 class="font-16">{{ $t('Low') }}</h4>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex d-flex align-center justify-end>
                      <v-btn slot="activator" @click="cabinet_filter_dialog = true" style="border-radius: 5px" color="#812E81" class="white--text">
                        <v-icon>mdi-filter</v-icon>
                        <span :class="language === 'en' ? 'ml-2' : 'mr-2'" class="text-transform-none subheading font-weight-medium">{{ $t('Filter By') }}</span>
                      </v-btn>
                      <v-btn v-if="type === 'alerts' && filtered_cabinets.length" @click="exportData" style="border-radius: 5px" color="#292F7D" class="white--text">
                        <v-icon>mdi-export</v-icon>
                        <span :class="language === 'en' ? 'ml-2' : 'mr-2'" class="text-transform-none subheading font-weight-medium">{{ $t('Export Data') }}</span>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-flex>
      <span v-if="general_alerts.length" class="subheading font-weight-bold mt-4">{{ $t('Flood Alerts') }}</span>
      <v-flex v-if="general_alerts.length" xs12 style="margin-top: 10px" class="blue-rounded-card">
        <GeneralAlerts :tableData="general_alerts" />
      </v-flex>
      <span v-if="cabinets.length > 0 && general_alerts.length > 0" class="subheading font-weight-bold mt-4">{{ $t('Cabinet Alerts') }}</span>
      <v-flex xs12>
        <ProjectCabinetTable ref="cabinets_table" :tableData="filtered_cabinets" />
      </v-flex>
      <v-flex v-if="cabinets.length > 0 && filtered_cabinets.length === 0" xs12>
        <v-layout justify-center class="blue-rounded-card pa-3 mt-3">
          <h2>{{ $t('There are no matching results for your filter') }}</h2>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-else>
      <v-layout v-if="type === 'events'" justify-center class="mt-3">
        <h1>{{ $t('There are no events for this project') }}</h1>
      </v-layout>
      <v-layout v-else justify-center class="mt-3">
        <h1>{{ $t('There are no alerts for this project') }}</h1>
      </v-layout>
    </v-layout>
    <FilterDialog 
      v-if="cabinet_filter_dialog"
      :filters="filters"
      :today="today_string"
      :yesterday="yesterday_string"
      :last_week="last_week"
      :getIncidentTypeName="getIncidentTypeName"
      @updateFilters="updateFilters"
      @close="cabinet_filter_dialog = false"
    />
  </v-layout>
</template>

<script>
import ProjectCabinetTable from '@/pages/alertManagement/components/ProjectCabinetTable.vue';
import GeneralAlerts from '@/pages/alertManagement/components/GeneralAlerts.vue';
import Utils from '@/modules/Utils';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import moment from 'moment-timezone';
import FilterDialog from '@/pages/alertManagement/components/FilterDialog.vue';
import { alerts_with_header_1, alerts_with_header_2, alerts_with_header_3, event_abnormal_types, event_consumption_anomalies_types, event_consumption_during_day_types, single_unit_alert_types, single_unit_probability_alert_types } from '@/store/modules/Global';
import { saveAs } from 'file-saver';
import Excel from 'exceljs';
import { getIncidentTypeName } from '@/modules/IncidentTypeUtils';

export default {
  name: 'AlertManagment',
  props: ['default_filter'],
  components: { ProjectCabinetTable, GeneralAlerts, FilterDialog },
  data() {
    return {
      single_unit_all_alerts: single_unit_alert_types.concat(single_unit_probability_alert_types),
      cabinets: [],
      cabinetsSignature: '',
      filteredCabinetsSignature: '',
      incidentsCount: 0,
      high: null,
      mid: null,
      low: null,
      type: '',
      loading: true,
      hasBuiltOnce: false,
      general_alerts: [],
      search: '',
      selectedValue: '',
      items: [],
      search_loading: false,
      filters: null,
      cabinet_filter_dialog: false,
      filtered_cabinets: [],
      project_id: null,
      today_string: '',
      yesterday_string: '',
      last_week: '',
      runPageTimer: null,
      isBuildingPage: false
    };
  },
  beforeMount() {
    this.type = this.$route.path.includes('alerts') && 'alerts' || 'events';
    if (this.type === 'alerts') this.$store.commit('Global/setPageTitle', 'Alert Management');
    else if (this.type === 'events') this.$store.commit('Global/setPageTitle', 'Event Management');
    this.setProjectId();
  },
  mounted() {
    this.scheduleRunPage();
  },
  methods: {
    getIncidentTypeName(incidentType) {
      return getIncidentTypeName(incidentType, this.type === 'events', this.language);
    },
    hasExistingIncidents() {
      return this.type === 'alerts' ? this.projectAlerts.length > 0 : this.projectEvents.length > 0;
    },
    cabinetsReady() {
      const commissionedCabinets = this.$store.getters['Reports/commissionedCabinets'] || [];
      return this.cabinetsCount !== -1 || commissionedCabinets.length > 0;
    },
    setProjectId(){
      this.project_id = this.$route.params.pid || this.$store.state.User.project.id;
    },
    getPriorityFilter(incident, incidentType) {
      if (incidentType === 'alerts') {
        return incident.priority;
      }
      if (event_consumption_anomalies_types.includes(incident.event_type)) return 3;
      if (event_abnormal_types.includes(incident.event_type)) return 2;
      if (event_consumption_during_day_types.includes(incident.event_type)) return 1;
      return 0;
    },
    sortIncidentsByPriority(incidents, incidentType) {
      const priorityGroups = { high: [], mid: [], low: [] };
      
      incidents.forEach((incident) => {
        const priority = this.getPriorityFilter(incident, incidentType);
        if (priority === 3) priorityGroups.high.push(incident);
        else if (priority === 2) priorityGroups.mid.push(incident);
        else if (priority === 1) priorityGroups.low.push(incident);
      });
      
      Object.keys(priorityGroups).forEach((key) => {
        priorityGroups[key].sort((a, b) => a.time - b.time);
      });
      
      return {
        ordered: [...priorityGroups.high, ...priorityGroups.mid, ...priorityGroups.low],
        counts: {
          high: priorityGroups.high.length,
          mid: priorityGroups.mid.length,
          low: priorityGroups.low.length
        }
      };
    },
    buildIncidentsByCabinetMap(incidents) {
      const incidentsByCabinetId = new Map();
      incidents.forEach((incident) => {
        const cabinetId = incident.cabinet_id;
        if (!cabinetId) return;
        if (!incidentsByCabinetId.has(cabinetId)) {
          incidentsByCabinetId.set(cabinetId, []);
        }
        incidentsByCabinetId.get(cabinetId).push(incident);
      });
      return incidentsByCabinetId;
    },
    calculatePriorityCounts(incidents, incidentType) {
      let high = 0, mid = 0, low = 0;
      
      incidents.forEach((incident) => {
        const priority = this.getPriorityFilter(incident, incidentType);
        if (priority === 3) high++;
        else if (priority === 2) mid++;
        else if (priority === 1) low++;
      });
      
      return { high, mid, low };
    },
    getActiveFilters() {
      return (this.filters || [])
        .filter((filter) => filter.type !== 'date')
        .filter((filter) => {
          const selected = [...filter.options.entries()].filter(([, value]) => value);
          return selected.length;
        });
    },
    getSelectedFilterOptions(filter) {
      return [...filter.options.entries()]
        .filter(([, val]) => val)
        .map(([key]) => key.trim());
    },
    getDateFilter() {
      const date_filter = this.filters && this.filters.find((filter) => filter.type === 'date' && filter.active);
      if (date_filter) {
        if (!date_filter.from) date_filter.from = this.today_string;
        if (!date_filter.to) date_filter.to = this.today_string;
      }
      return date_filter;
    },
    matchesFilters(incident, cabinet, activeFilters, dateFilter) {
      if (dateFilter) {
        const incidentDate = moment(moment(incident.time).tz(this.projectTimezone).format('YYYY-MM-DD'));
        if (!incidentDate.isBetween(dateFilter.from, dateFilter.to, undefined, '[]')) return false;
      }

      for (const filter of activeFilters) {
        const selected_options = this.getSelectedFilterOptions(filter);
        if (filter.hasOwnProperty('cabinet_field_name') && cabinet[filter.cabinet_field_name]) {
          const field_val = `${cabinet[filter.cabinet_field_name]}`.trim();
          if (!selected_options.includes(field_val)) return false;
        } else {
          const actualFieldName = filter.field_name === 'incident_type' && this.type === 'events' ? 'event_type' : filter.field_name;
          const field_val = `${incident[actualFieldName]}`.trim();
          if (!selected_options.includes(field_val)) return false;
        }
      }

      return true;
    },
    scheduleRunPage() {
      if (this.runPageTimer) {
        clearTimeout(this.runPageTimer);
      }
      this.runPageTimer = setTimeout(() => {
        this.runPageTimer = null;
        this.runPage();
      }, 0);
    },
    async runPage() {
      if (this.isBuildingPage) return;
      this.isBuildingPage = true;

      try {
        const cabinetsReady = this.cabinetsReady();

        if (!cabinetsReady) {
          return;
        }

        await new Promise((resolve) => requestAnimationFrame(resolve));

        if ((this.type === 'alerts') && this.projectAlerts.length !== 0) {
          this.setProjectAlerts();
        }else if (this.type === 'events' && this.projectEvents.length !== 0){
          this.setProjectEvents();
        }
      } finally {
        this.isBuildingPage = false;
        if (!this.hasBuiltOnce) {
          const cabinetsReady = this.cabinetsReady();
          this.loading = (this.isLoadingIncidents && !this.hasExistingIncidents()) || !cabinetsReady;
          if (!this.loading) {
            this.hasBuiltOnce = true;
          }
        } else {
          this.loading = false;
        }
      }
    },
    setFilteredCabinets(next_filtered) {
      const sigType = this.type === 'events' ? 'events' : 'alerts';
      const nextSig = this.cabinetsSigById(next_filtered, sigType);
      if (this.filteredCabinetsSignature !== nextSig) {
        this.filteredCabinetsSignature = nextSig;
        this.filtered_cabinets = next_filtered;
        return true;
      }
      return false;
    },
    buildCabinetBase(cabinet) {
      const meta_device = cabinet && cabinet['meta.device'] ? cabinet['meta.device'] : {};
      const cabinet_id = meta_device.cabinet_id;

      return {
        id: cabinet.id,
        class_name: cabinet.class_name,
        sys___active: cabinet.sys___active,
        cabinetNumber: cabinet_id,
        roadNumber: meta_device.managed_area || meta_device.road || '',
        description: meta_device.description || ''
      };
    },
    cabinetsSigById(items, type) {
      if (!items || !items.length) return '';
      const countKey = type === 'events' ? 'events' : 'alerts';

      return items
        .map((c) => {
          const count = c && c[countKey] ? c[countKey].length : 0;
          return `${c.id}:${count}:${c.high}:${c.mid}:${c.low}`;
        })
        .sort()
        .join('|');
    },
    setProjectAlerts(){
      if (!this.projectAlerts.length) return;
      this.setGeneralAlerts();

      const alerts = this.projectAlerts.map((alert) => ({...alert, time: moment(alert.created).valueOf()}));
      const alertsPriorityMetricsByCabinet = this.$store.state.Projects.alertsPriorityMetricsByCabinet;
      const alertsByPriority = this.$store.getters['Projects/alertsByPriority'];
      
      this.high = alertsByPriority.high;
      this.mid = alertsByPriority.medium;
      this.low = alertsByPriority.low;
      this.incidentsCount = this.high + this.mid + this.low;

      const cabinets = this.buildCabinetsWithIncidents(alerts, 'alerts', alertsPriorityMetricsByCabinet);
      this.updateCabinetsAndFilters(cabinets, 'alerts');
    },
    setProjectEvents(){
      if (!this.projectEvents.length) return;

      const events = this.projectEvents.map((event) => ({...event, time: moment(event.created).valueOf()}));
      const priorityCounts = this.calculatePriorityCounts(events, 'events');
      
      this.incidentsCount = events.length;
      this.high = priorityCounts.high;
      this.mid = priorityCounts.mid;
      this.low = priorityCounts.low;

      const cabinets = this.buildCabinetsWithIncidents(events, 'events');
      this.updateCabinetsAndFilters(cabinets, 'events');
    },
    buildCabinetsWithIncidents(incidents, incidentType, metricsMap = null) {
      const cabinetsSource = this.$store.getters['Reports/commissionedCabinets'] || [];
      const incidentsByCabinetId = this.buildIncidentsByCabinetMap(incidents);
      const incidentKey = incidentType === 'events' ? 'events' : 'alerts';

      return cabinetsSource
        .map((cabinet) => {
          const base = this.buildCabinetBase(cabinet);
          const cabinet_id = cabinet['meta.device'].cabinet_id;
          const cabinetIncidents = cabinet_id ? (incidentsByCabinetId.get(cabinet_id) || []) : [];

          if (!cabinetIncidents.length) {
            return {
              ...base,
              [incidentKey]: [],
              high: 0,
              mid: 0,
              low: 0,
              ...(incidentType === 'alerts' && { grade: '' })
            };
          }

          const { ordered, counts } = this.sortIncidentsByPriority(cabinetIncidents, incidentType);
          const result = {
            ...base,
            [incidentKey]: ordered,
            ...counts
          };

          if (incidentType === 'alerts' && metricsMap) {
            const metrics = cabinet_id && metricsMap.has(cabinet_id) ? metricsMap.get(cabinet_id) : null;
            result.grade = metrics ? metrics.grade : '';
          }

          return result;
        })
        .filter((cabinet) => cabinet[incidentKey].length);
    },
    updateCabinetsAndFilters(cabinets, incidentType) {
      const nextSig = this.cabinetsSigById(cabinets, incidentType);
      const cabinetsChanged = this.cabinetsSignature !== nextSig;
      if (cabinetsChanged) {
        this.cabinetsSignature = nextSig;
        this.cabinets = cabinets;
      }

      const final_filters = this.getFilterOptions(this.filters);
      let shouldRegenerateTable = false;

      if ((this.default_filter && incidentType === 'alerts') || (this.filters && this.filters.length)) {
        const filtersChanged = !isEqual(this.filters, final_filters);
        if (filtersChanged) this.filters = final_filters;
        if (filtersChanged || cabinetsChanged) {
          const next_filtered = this.getFilteredCabinets();
          shouldRegenerateTable = this.setFilteredCabinets(next_filtered);
        }
      } else {
        this.filters = final_filters;
        shouldRegenerateTable = this.setFilteredCabinets([...this.cabinets]);
      }

      if (shouldRegenerateTable) {
        this.$nextTick(() => {
          if (this.$refs.cabinets_table) {
            this.$refs.cabinets_table.generateCabinetsTable(this.filtered_cabinets);
          }
        });
      }
    },
    getFilteredCabinets(){
      const incident_type = this.type === 'events' ? 'events' : 'alerts';
      const dateFilter = this.getDateFilter();
      const activeFilters = this.getActiveFilters();

      return this.cabinets.filter((cabinet) => {
        const incidents = cabinet[incident_type] || [];
        return incidents.some((incident) => this.matchesFilters(incident, cabinet, activeFilters, dateFilter));
      });
    },
    getFilterOptions(prev_filters){
      let filters = prev_filters && prev_filters.length > 1 ? cloneDeep(prev_filters) : [];
      const incidents_list = this.type === 'events' && 'event' || 'alert';
      
      const options = {};

      if (!filters.length) {
        const today_timestamp = moment().unix() * 1000;
        this.today_string = Utils.convertTimestamp(today_timestamp, 'YYYY-MM-DD', this.projectTimezone);
        this.yesterday_string = Utils.removeFromTimestamp_string(today_timestamp, 'days', 1, 'YYYY-MM-DD', this.projectTimezone);
        this.last_week = Utils.removeFromTimestamp_string(today_timestamp, 'weeks', 1, 'YYYY-MM-DD', this.projectTimezone);

        let range = null;

        if (this.type === 'alerts' && this.default_filter) {
          range = this.getFilterRange();
        }

        filters = [
          {
            name: 'Date',
            type: 'date',
            active: range ? true : false,
            from: range && range.from || this.yesterday_string,
            to: range && range.to || this.today_string
          },
          {
            name: 'Managed Area',
            type: 'multiselect',
            field_name: 'managed_area',
            cabinet_field_name: 'roadNumber',
            options: new Map()
          },
          {
            name: 'Cabinet Description',
            type: 'multiselect',
            field_name: 'description',
            cabinet_field_name: 'description',
            options: new Map()
          },
          {
            name: 'Socket Type',
            type: 'checkbox',
            field_name: 'socket_type',
            single_unit: true,
            options: new Map()
          },
          {
            name: incidents_list === 'event' ? 'Event Type' : 'Alert Type',
            type: 'checkbox',
            field_name: 'incident_type',
            options: new Map(),
            use_fetched_types: true
          }
        ];
      }

      filters.forEach((filter) => {
        if (!filter.hasOwnProperty('options')) return;
        
        options[`${filter.field_name}_set`] = new Set();

        if (filter.use_fetched_types && filter.field_name === 'incident_type') {
          const typesData = this.type === 'events' 
            ? this.$store.state.Projects.eventTypes 
            : this.$store.state.Projects.incidentTypes;
          const typeKey = this.type === 'events' ? 'event_type' : 'incident_type';
          
          typesData.forEach((typeItem) => {
            const incidentTypeValue = typeItem[typeKey];
            const hasOpenIncident = this.cabinets.some((cabinet) => 
              cabinet[`${incidents_list}s`].some((incident) => {
                const incidentTypeField = this.type === 'events' ? incident.event_type : incident.incident_type;
                return incidentTypeField === incidentTypeValue;
              })
            );
            
            if (hasOpenIncident) {
              options[`${filter.field_name}_set`].add(incidentTypeValue.trim());
            }
          });
        } else {
          this.cabinets.forEach((cabinet) => {
            if (filter.hasOwnProperty('cabinet_field_name') && cabinet[filter.cabinet_field_name]) {
              options[`${filter.field_name}_set`].add(`${cabinet[filter.cabinet_field_name]}`.trim());
            }else if (!filter.hasOwnProperty('cabinet_field_name')){
              const type = `${incidents_list}_type`;

              cabinet[`${incidents_list}s`].forEach((incident) => {
                let incident_field_value = incident[filter.field_name] ? `${incident[filter.field_name]}` : '';
                if (filter.single_unit && !this.single_unit_all_alerts.includes(incident[type])) {
                  incident_field_value = '';
                }
                if (incident_field_value) {
                  options[`${filter.field_name}_set`].add(incident_field_value.trim());
                }
              });
            }
          });
        }
      });

      filters.forEach((filter) => {
        if (filter.hasOwnProperty('options')){
          const options_arr = [...options[`${filter.field_name}_set`]];
          options_arr.sort((a, b) => a.localeCompare(b, undefined, {numeric: true, sensitivity: 'base'}));

          if (filter.options.size){
            const filter_options_map = new Map();
            options_arr.forEach((option) => {
                if (filter.options.has(option)) {
                  filter_options_map.set(option, filter.options.get(option));
                } else {
                  filter_options_map.set(option, false);
                }
            });
            filter.options = filter_options_map;
          }else if (options[`${filter.field_name}_set`].size){
            options_arr.forEach((option) => filter.options.set(option, false));
          }else {
            filter.options = new Map();
          }
        }
      });
      
      return filters;
    },
    getFilterRange(){
      const range = { from: null, to: null };

      switch (this.default_filter){
        case 'yesterday':
          range.from = this.yesterday_string;
          range.to = this.yesterday_string;
          break;
        case 'week':
          range.from = this.last_week;
          range.to = this.today_string;
          break;
        default:
          range.from = this.yesterday_string;
          range.to = this.today_string;
          break;
      }

      return range;
    },
    updateCabinetsList(){
      const next_filtered = this.getFilteredCabinets();
      this.setFilteredCabinets(next_filtered);
    },
    updateFilters(filters){
      this.filters = filters.map((filter) => {
        if (filter.type === 'multiselect'){
          delete filter.selected_values;
        }
        return filter;
      });
      
      this.updateCabinetsList();
      this.$nextTick(() => {
        if (this.$refs.cabinets_table) {
          this.$refs.cabinets_table.generateCabinetsTable(this.filtered_cabinets);
        }
      });
    },
    setGeneralAlerts(){
      this.setFloodAlerts();
    },
    setFloodAlerts(){
      if (!this.projectAlerts.length) return;

      let flood_alerts = this.projectAlerts.filter(
        (alert) => alert.incident_type.toLowerCase().includes('flood') && alert.project_id === this.project_id
      );

      const ruleBoardsById = new Map();
      (this.rule_boards || []).forEach((d) => {
        if (d && d.id !== undefined && d.id !== null) {
          ruleBoardsById.set(d.id, d);
        }
      });

      flood_alerts = flood_alerts.map((alert) => (
        {
          priority_id: alert.priority,
          managed_area: (ruleBoardsById.get(alert.device_id) && ruleBoardsById.get(alert.device_id).name) || '',
          incident_id: alert.id,
          updated_at: moment(alert.modified).valueOf()
        }
      ));
      if (!isEqual(this.general_alerts, flood_alerts)) {
        this.general_alerts = flood_alerts;
      }
    },
    exportData(){
      const cabinet_alert_types = alerts_with_header_1.concat(alerts_with_header_2).concat(alerts_with_header_3);
      const cabinets_alerts = [], single_unit_alerts = [];
      const incident_type = this.type === 'events' ? 'events' : 'alerts';
      const dateFilter = this.getDateFilter();
      const activeFilters = this.getActiveFilters();

      this.filtered_cabinets.forEach((cabinet) => {
        const filtered_alerts = cabinet[incident_type].filter((incident) => 
          this.matchesFilters(incident, cabinet, activeFilters, dateFilter)
        );

        filtered_alerts.forEach((alert) => {
          const alert_data_start = {
            incident_id: `${alert.id}`,
            incident_type: this.getIncidentTypeName(alert.incident_type),
            priority: this.$t(Utils.getAlertPriority(alert.priority)),
            cabinet_id: cabinet.cabinetNumber || this.$t('no data'),
            managed_area: cabinet.roadNumber || this.$t('no data')
          };

          const device_id = alert.device_id;

          const alert_data_end = {
            creation_date: Utils.convertTimestamp(alert.time, 'DD/MM/YYYY HH:mm:ss', this.projectTimezone),
            device_id
          };

          if (cabinet_alert_types.includes(alert.incident_type)) {
            alert_data_start.details = alerts_with_header_2.includes(alert.incident_type) 
              ? alert.phase && alert.phase !== 'no data' ? `${this.$t('Phase')} ${Utils.convertNumberToRealPhase(alert.phase)}` : this.$t('no data')
              : alerts_with_header_3.includes(alert.incident_type)
                ? alert.circuit_number && alert.circuit_number !== 'no data' ? `${this.$t('Circuit')} ${alert.circuit_number}` : this.$t('no data')
                : '';
            alert_data_start.circuit_number = alerts_with_header_3.includes(alert.incident_type) ? this.$t(alert.circuit_number) || this.$t('no data') : '';
            alert_data_start.pole_number = '';
            alert_data_start.phase = alerts_with_header_2.includes(alert.incident_type) ? this.$t(Utils.convertNumberToRealPhase(alert.phase)) || this.$t('no data') : '';
            cabinets_alerts.push({...alert_data_start, ...alert_data_end});
          }else if (this.single_unit_all_alerts.includes(alert.incident_type)){
            const device = this.$store.getters['Reports/commissionedFixtures_map'].get(alert.device_id);
            alert_data_start.circuit_number = this.$t(alert.circuit_number) || this.$t('no data');
            alert_data_start.pole_number = this.$t(alert.pole_number) || this.$t('no data');
            alert_data_start.phase = this.$t(alert.phase) || this.$t('no data');
            alert_data_start.road_curbs = device && this.$t(device['meta.device'].road_curbs) || this.$t('no data');
            alert_data_start.socket_type = alert.socket_type || this.$t('no data');

            single_unit_alerts.push({...alert_data_start, ...alert_data_end});
          }
        });
      });
      this.generateExcel(cabinets_alerts, single_unit_alerts);
    },
    generateExcel(cabinets_alerts, single_unit_alerts){
      const workbook = new Excel.Workbook();
      const columns_start = [
        { header: this.$t('Incident Id'), key: 'incident_id', width: 30 },
        { header: this.$t('Alert Type'), key: 'incident_type', width: 20 },
        { header: this.$t('Priority'), key: 'priority', width: 15 },
        { header: this.$t('Cabinet Id'), key: 'cabinet_id', width: 15 },
        { header: this.$t('Managed Area'), key: 'managed_area', width: 15 }
      ];
      const single_unit_columns = [
        { header: this.$t('Circuit Number'), key: 'circuit_number', width: 20 },
        { header: this.$t('Pole Number'), key: 'pole_number', width: 20 },
        { header: this.$t('Phase'), key: 'phase', width: 20 },
        { header: this.$t('Road Curbs'), key: 'road_curbs', width: 15 },
        { header: this.$t('Socket Type'), key: 'socket_type', width: 20 }
      ];
      const cabinets_columns = [
        { header: this.$t('Details'), key: 'details', width: 20 }
      ];
      const columns_end = [
        { header: this.$t('Date Time'), key: 'creation_date', width: 20 },
        { header: this.$t('Device Id'), key: 'device_id', width: 35 }
      ];

      let cabinets_sheet = null, single_unit_sheet = null, all_sheet = null;
      if (cabinets_alerts.length && single_unit_alerts.length){
        all_sheet = workbook.addWorksheet(this.$t('All'));
        all_sheet.columns = columns_start.concat(single_unit_columns).concat(columns_end);
        all_sheet.addRows(cabinets_alerts.concat(single_unit_alerts));
      }
      if (cabinets_alerts.length) {
        cabinets_sheet = workbook.addWorksheet(this.$t('Cabinet Alerts'));
        cabinets_sheet.columns = columns_start.concat(cabinets_columns).concat(columns_end);
        cabinets_sheet.addRows(cabinets_alerts);
      }
      if (single_unit_alerts.length) {
        single_unit_sheet = workbook.addWorksheet(this.$t('Single Unit Alerts'));
        single_unit_sheet.columns = columns_start.concat(single_unit_columns).concat(columns_end);
        single_unit_sheet.addRows(single_unit_alerts);
      }

      workbook.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8;'});
        saveAs(blob, `${this.project.name}_alerts_${Utils.getNow(this.projectTimezone)}.xlsx`);
      });
    }
  },
  computed: {
    isLoadingIncidents(){
      return this.type === 'alerts'
        ? this.$store.state.Projects.isLoadingAlerts
        : this.$store.state.Projects.isLoadingEvents;
    },
    isDevicesLoaded(){
      return this.devicesCount !== -1 && this.devices && this.devices.length === this.devicesCount;
    },
    projectTimezone() {
      return this.$store.state.Global.timezone || 'Asia/Tel_Aviv';
    },
    project() {
      return this.$store.state.User.project;
    },
    rule_boards(){
      return this.$store.getters['Reports/ruleBoards'];
    },
    projectAlerts(){
      return this.$store.state.Projects.projectAlerts;
    },
    projectEvents(){
      return this.$store.state.Projects.projectEvents;
    },
    language() {
      return this.$store.state.Global.lang;
    },
    devicesCount() {
      return this.$store.state.Reports.devicesCount;
    },
    devices() {
      return this.$store.state.Reports.reportsList;
    },
    projectsList(){
      return this.$store.state.Projects.list;
    },
    cabinetsCount(){
      return this.$store.state.Reports.cabinetsCount;
    }
  },
  watch: {
    projectAlerts(prev, next) {
      if (this.type === 'alerts' && !isEqual(prev, next)) {
        this.scheduleRunPage();
      }
    },
    projectEvents(prev, next) {
      if (this.type === 'events' && !isEqual(prev, next)) {
        this.scheduleRunPage();
      }
    },
    isDevicesLoaded(next, prev) {
      if (next && !prev) {
        this.$nextTick(() => {
          if (this.$refs.cabinets_table) {
            this.$refs.cabinets_table.generateCabinetsTable(this.filtered_cabinets);
          }
        });
      }
    },
    devices() {
      this.scheduleRunPage();
    },
    projectsList(){
      const project_id = this.project_id;
      this.setProjectId();
      if (project_id !== this.project_id){
        this.scheduleRunPage();
      }
    }
  }
};
</script>

<style scoped>
  /* width */
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 5px;
    margin: 6px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #292f7d;
    border-radius: 5px;
  }

.cabinetSelector{
  cursor: pointer;
  font-weight: bold;
  font-size: 18px;
  color:blue;
}
.tabs-items {
  background-color: #f2f4f8;
  
}

.imagePlace {
  margin-top: 8px;
  margin-left: 10px;
  margin-right: 10px;
}
@media (min-width: 480px) {
  .font-34 {
    margin: 0px 5px;
  }
  .font-16 {
    margin: 0px 5px;
  }
}
@media (max-width: 479px) {
  .font-34 {
    margin: 0px 10px;
  }
  .font-16 {
    margin: 0px 10px;
  }
}
.iconSize {
  height: 20px;
  width: 20px;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}
.modal-container-small {
  width: 500px;
  margin: 0px auto;
  height: fit-content;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}
.closeIcon {
  position: absolute;
  top: 8px;
  right: 10px;
  cursor: pointer;
}
.selectHeader{
  font-weight: bold;
  font-size: 18px;
}
</style>
